import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer, FileDown } from "lucide-react";
import { toast } from "sonner";

// Preview file in-app (PDF & gambar) — tidak memakai window.open agar tidak
// terkena popup blocker. Dipakai untuk bukti tanda terima & lampiran PO/WO order.
export const FilePreviewDialog = ({ file, onClose }) => {
  // file = { url, nama, tipe }
  const print = () => {
    const frame = document.getElementById("file-preview-frame");
    try {
      frame?.contentWindow?.focus();
      frame?.contentWindow?.print();
    } catch {
      toast.error("Gagal membuka dialog print — gunakan tombol Unduh");
    }
  };
  const unduh = () => {
    if (!file?.url) return;
    const a = document.createElement("a");
    a.href = file.url;
    a.download = file.nama || "dokumen";
    a.click();
  };
  const isImage = (file?.tipe || "").startsWith("image/");
  return (
    <Dialog open={!!file} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-3xl" data-testid="file-preview-dialog">
        <DialogHeader>
          <DialogTitle className="truncate pr-6">{file?.judul || file?.nama || "Preview Dokumen"}</DialogTitle>
          <DialogDescription>Periksa dokumen lalu klik Print atau Unduh bila diperlukan.</DialogDescription>
        </DialogHeader>
        {file && (
          isImage ? (
            <div className="w-full h-[65vh] rounded-md border border-slate-200 bg-slate-50 overflow-auto flex items-start justify-center">
              <img src={file.url} alt={file.nama || "Preview"} className="max-w-full h-auto"
                data-testid="file-preview-image" />
              {/* iframe tersembunyi untuk print gambar */}
              <iframe id="file-preview-frame" title="Print" src={file.url}
                className="hidden" />
            </div>
          ) : (
            <iframe id="file-preview-frame" title={file.nama || "Preview"} src={file.url}
              className="w-full h-[65vh] rounded-md border border-slate-200 bg-slate-50"
              data-testid="file-preview-frame" />
          )
        )}
        <p className="text-[11px] text-slate-400">
          Jika preview tidak tampil di perangkat Anda, klik tombol <span className="font-medium">Unduh</span>.
        </p>
        <div className="flex flex-wrap gap-2 justify-end">
          <Button variant="outline" onClick={onClose} data-testid="file-preview-close">Tutup</Button>
          <Button variant="outline" onClick={unduh} data-testid="file-preview-download"
            className="gap-2 border-emerald-200 text-emerald-700 hover:bg-emerald-50">
            <FileDown className="h-4 w-4" /> Unduh
          </Button>
          <Button onClick={print} data-testid="file-preview-print"
            className="gap-2 bg-blue-600 hover:bg-blue-700 text-white">
            <Printer className="h-4 w-4" /> Print
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
